<div class="item-inner">
	<div class="item-header text-4 col-12">
		{{ questionnaire.name }}
	</div>
	<div class="item-content col-12">
		<div>{{ 'blocklist.questionnaire.questions' | translate }}</div>
		<div class="amount text-bold-2">
			{{ questionnaire.questionnaireQuestions.length }}
		</div>
	</div>
</div>